.sidebar-container {
    width: 200px;
}

.table-wrapper {
    width: calc(100% - 200px);
}

@media (max-width: 1199px) {
    .sidebar-container {
        display: none;
    }
    .table-wrapper {
        width: 100%;
    }
}
